import { render, staticRenderFns } from "./IncreaseFunds.vue?vue&type=template&id=893a8c2c&scoped=true&"
import script from "./IncreaseFunds.vue?vue&type=script&lang=js&"
export * from "./IncreaseFunds.vue?vue&type=script&lang=js&"
import style0 from "./IncreaseFunds.vue?vue&type=style&index=0&id=893a8c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a8c2c",
  null
  
)

export default component.exports